import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, shareReplay } from 'rxjs/operators';
import { environment } from '../../../environment';
import { BrandingInfo, DEFAULT_BRAND_NAME } from '../models/branding.model';

/**
 * Gym brand resolved by the backend (single source of truth), via public endpoints.
 * The frontend is a generic image; it does not decide the brand.
 */
@Injectable({ providedIn: 'root' })
export class BrandingService {
  private readonly baseUrl = `${environment.apiUrl}/public/branding`;

  // The brand cannot change during the SPA's lifetime (switching GYM_BRAND needs a
  // backend redeploy), so cache it and share one request across all consumers.
  private readonly info$ = this.http.get<BrandingInfo>(`${this.baseUrl}/info`).pipe(
    // Deliberately silent: a branding failure must not spam the login with a toastr,
    // so this does NOT go through ErrorHandlerService.
    catchError(() => of({ brand: 'default', name: DEFAULT_BRAND_NAME })),
    shareReplay({ bufferSize: 1, refCount: false }),
  );

  constructor(private readonly http: HttpClient) {}

  /** Active brand logo URL, for direct use in <img [src]>. */
  get logoUrl(): string {
    return `${this.baseUrl}/logo`;
  }

  /** Brand name/key to label the UI; falls back to the product name on failure. */
  getInfo(): Observable<BrandingInfo> {
    return this.info$;
  }
}
